import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full px-4 md:px-6 lg:px-12 py-12 md:py-16 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">最新动态</h2>
        <div className="relative">
          <div className="absolute left-3 top-2 bottom-2 w-px bg-background-300 hidden md:block"></div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {updatesData.map((item, idx) => (
              <div key={item.id} className="relative flex gap-4 pl-0 md:pl-10">
                <div className="hidden md:flex absolute left-2 top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex-1 bg-background-100 rounded-lg p-4 border border-background-200/60 transition-all hover:border-primary-200/60">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}